import { getBaseIconResourceUrl } from "../utils/util";
import config from "../../config";

export const DEFAULT_DOMAIN = process.env.APP_ENV === "staging" ? config.staging.domain : config.dev.domain;
export const LOCALSTORAGE_ENV = "dev";

// Delay (ms) after save API completes before unblocking navigation.
// Allows pending async operations (cache writes, state updates) to settle.
export const SAVE_SETTLE_DELAY_MS = 300;

export const SERVICE_LINKS = {
    EPC_LABEL_URL: `https://epclabel.${DEFAULT_DOMAIN}`,
    MAP_WEBAPP_URL: `https://map.${DEFAULT_DOMAIN}/1.4/webapp.html`,
    WEBSITE_URL: `https://${DEFAULT_DOMAIN}`,
    EXCHANGE_URL: `exchange.${DEFAULT_DOMAIN}`,
    ID_SCANNER_URL: `https://idscanner.${DEFAULT_DOMAIN}/?iframe=true`,
    ID_SCANNER_DOMAIN: `https://idscanner.${DEFAULT_DOMAIN}`,
    CONSENT_URL: `https://consent.${DEFAULT_DOMAIN}`,
    IMMOVIETNAM_LOGIN_URL: `immovietnam.${DEFAULT_DOMAIN}/login`,
    AUTH_WEB_LOGOUT_URL: `//auth.${DEFAULT_DOMAIN}/auth/web/logout/`,
    AUTH_URL: `https://auth.${DEFAULT_DOMAIN}`,
    OMNICASAMAP_URL: `https://geomap.${DEFAULT_DOMAIN}/Page/OmnicasaMap.aspx`,
    SERVICE_DEMOMAP_URL: `https://service.${DEFAULT_DOMAIN}/demomap/?region=`,
    SHARE_CLOUD_STORAGE_URL: `https://cloud-storage.${DEFAULT_DOMAIN}/share`,
    ICON_RESOURCE_URL: `https://cloud-storage.${DEFAULT_DOMAIN}/share/omnicasa.resources/web-app/icons`
};

export const RESOURCE_LINKS = {
    GENERAL_NOFILEPNG_URL: `${SERVICE_LINKS.ICON_RESOURCE_URL}/general/nofile.png`,
    TASKTYPE_PRIVATE_ICON_URL: `${SERVICE_LINKS.ICON_RESOURCE_URL}/TaskType/private.ico`,
    OBJECTSTORAGE_WEBAPP_ICON_URL: `${SERVICE_LINKS.ICON_RESOURCE_URL}`,
    DOCUMENT_JPGPNG_URL: `${SERVICE_LINKS.ICON_RESOURCE_URL}/Document/jpg.png`,
    WEBAPP_ICON_SMALL_NOPIC_URL: `${SERVICE_LINKS.ICON_RESOURCE_URL}/small/no_pic.gif`,
    MAP_DESIGNED_ICON_URL: `https://geomap.${DEFAULT_DOMAIN}/map/img/designed/ico_04.png`,
    WEBAPP_ICONS_SMALL_URL: `${SERVICE_LINKS.ICON_RESOURCE_URL}/small/`,
    EXTERNAL_SUPPLIER_ICON_URL: `https://cloud-storage.${DEFAULT_DOMAIN}/share/omnicasa.resources/web-app/icons/keuringsplatform/`,
    CONGRAT_SMOOVED_REMINDER_ICON_URL: `https://objectstorage2.${DEFAULT_DOMAIN}/data.share/omnicasa.resources/web-app/icons/general/congrat-sell.svg`,
    CONFIRMATION_ICON_URL: `https://objectstorage2.${DEFAULT_DOMAIN}/data.share/omnicasa.resources/web-app/icons/general/bg-congrat.png`,
    REALSMART_ICON_URL: `https://storage.googleapis.com/share.omnicasapictures.com/data.share/omnicasa.resources/web-app/icons/keuringsplatform/realsmart.png`,
    SMS_ICON_URL: `https://cdn.omnicasaassets.com/public/omnicasaresources/images/webapp/icons/ico_sms_np.svg`,
    SMS_GREEN_ICON_URL: `https://cdn.omnicasaassets.com/public/omnicasaresources/images/webapp/icons/ico_sms_np_green.svg`,
    INPRESS_ICON_URL: `https://cdn.omnicasaassets.com/public/omnicasaresources/assets/inpress_thumbnail_48x48.png`
};

export const PAGINATION_SIZE_MAX: number = 2147483647;
export const PAGINATION_SIZE: number = 20;
export const PAGINATION_INDEX: number = 1;
export const PAGINATION_PAGE_SIZES: number[] = [5, 10, 20, 50, 100];

export const X_PAGINATION_PAGE_COUNT = "x-pagination-page-count";
export const X_PAGINATION_PAGE_SIZE = "x-pagination-page-size";
export const X_PAGINATION_PAGE_INDEX = "x-pagination-page-index";
export const X_PAGINATION_TOTAL = "x-pagination-total";

export const LOCALSTORAGE_LANG = "lang";
export const LOCALSTORAGE_AUTH = "auth";
export const LOCALSTORAGE_AUTH2 = "AuthorizationData";
export const LOCALSTORAGE_USERSSION = "userssion";
export const LOCALSTORAGE_MAP_OPTIONS = "options";
export const LOCALSTORAGE_MAP_REGIONS = "regions";
export const LOCALSTORAGE_SIDEBAR_COLLAPSE_SETTING = "SideBarCollapseSetting";
export const LOCALSTORAGE_BASE_ICON_RESOURCE_URL = "baseIconResourceUrl";
export const LOCALSTORAGE_MASTER_USER = "loggedAsMaster";
export const LOCALSTORAGE_MASTER_PASS = "loggedWithMasterPassword";
export const LOCALSTORAGE_MASTER_AGENDA_SELECTED_USERS = "masterAgendaSelectedUsers";
export const LOCALSTORAGE_AI_TUTORIAL = "aiTutorial";
export const LOCALSTORAGE_AI_IMAGE_GENERATION_INTRODUCTION = "aiImageGenerationIntroduction";
export const APICONFIG_HEADER_AUTHORIZATION = "Authorization";
export const APICONFIG_HEADER_LANGUAGE = "Accept-Language";
export const APICONFIG_HEADER_SESSIONID = "X-App-SessionId";
export const APICONFIG_HEADER_MASTER_USER = "X-Master-User";
export const APICONFIG_HEADER_MASTER_PASSWORD = "X-Master-Password";
export const APICONFIG_LANGUAGE_ID = "LanguageID";

export const DATEFORMAT_SHORTDATE = "YYYYMMDD";
export const MASKS_DECIMAL: string[] = [
    "#.##",
    "##.##",
    "###.##",
    "####.##",
    "#####.##",
    "######.##",
    "#######.##",
    "########.##"
];

export const BELGIUM_LOCATION = {
    Latitude: 50.84670091541953,
    Longtitude: 4.352093604168658
};

export const AUTH_HEADER_MODE = "AuthMode";

export const SAVE_ACTION = {
    CLOSE_AFTER_SAVE: 0,
    NOT_CLOSE_AFTER_SAVE: 1,
    NEW_AFTER_SAVE: 2,
    VIEW_AFTER_SAVE: 3
};

export const FORMAT_DATE_EN = "MM/DD/YYYY";
export const FORMAT_DATE_NL = "DD/MM/YYYY";
export const FORMAT_DATE_FR = "DD/MM/YYYY";

export const MODAL_MODE = {
    MODAL: "MODAL",
    ROUTER_MODAL: "ROUTER_MODAL"
};

// Status base types from the Status/ProjectStatus lookups (backend Omnicasa.Common StatusBaseType).
export const STATUS_BASE_TYPE = {
    Prospection: 1,
    Active: 2
};

export const ROUTER = {
    AI_IMAGE: "ai-image",
    DOCUMENT_AI: "document-ai",
    EMAIL_WEBSITE: "email-website",
    KANBAN: "kanban-website",
    KANBAN_WEBVIEW: "kanban-webview",
    ASSISTANT_ARTIFACT: "assistant-artifact",
    ENQUIRY_CENTRE: "enquiry-centre",
    ENQUIRY_CENTRE_WEBVIEW: "enquiry-centre-webview",
    AGENDA_WEBVIEW: "agenda-webview",
    PROPERTY: {
        PROPERTY: "property",

        PROPERTY_GRID: "propertyGrid",
        PROPERTY_ICON: '<i class="fa fa-home"></i>',

        PROPERTY_SEND_MESSAGE: "propertySendMessage",
        PROPERTY_PRINT_TEMPLATE: "propertyPrintTemplate",
        PROPERTY_MODAL_TASK: "propertyModalTask",

        PROPERTY_NEW: "propertyNew",
        PROPERTY_NEW_NEW_PERSON: "propertyNewNewPerson",
        PROPERTY_NEW_OPEN_PERSON: "propertyNewOpenPerson",

        PROPERTY_EDIT: "propertyEdit",
        PROPERTY_EDIT_NEW_PERSON: "propertyEditNewPerson",
        PROPERTY_EDIT_OPEN_PERSON: "propertyEditOpenPerson",

        PROPERTY_PREPARE_NEW: "propertyPrepareNew",
        PROPERTY_PREPARE_PROJECT: "propertyPrepareProject",

        PROPERTY_PREPARE_CLONE: "propertyPrepareClone",

        PROPERTY_VIEW: "propertyView",
        PROPERTY_VIEW_SEND_MESSAGE: "propertyViewSendMessage",
        PROPERTY_VIEW_PROPERTY_SEND_MESSAGE: "propertyViewPropertySendMessage",
        PROPERTY_VIEW_MESSAGE_TO_RELATIONS: "propertyViewMessageToRelations",
        PROPERTY_VIEW_MESSAGE_TO_OWNER: "propertyViewMessageToOwner",
        PROPERTY_VIEW_PRINT_TEMPLATE: "propertyViewPrintTemplate",
        PROPERTY_VIEW_TO_PERSON_VIEW: "propertyViewToPersonView",
        PROPERTY_VIEW_TO_PERSON_EDIT: "propertyViewToPersonEdit",

        PROPERTY_MATCHING_DEMANDS: "propertyViewMatchingDemands",

        PROPERTY_PROJECT_VIEW: "propertyProjectView",
        PROPERTY_PROJECT_VIEW_PRINT_TEMPLATE:
            "propertyProjectViewPrintTemplate",
        PROPERTY_PROJECT_VIEW_SEND_MESSAGE: "propertyProjectViewSendMessage",
        PROPERTY_PROJECT_VIEW_MESSAGE_TO_RELATIONS:
            "propertyProjectViewMessageToRelations",
        PROPERTY_PROJECT_VIEW_MESSAGE_TO_OWNER:
            "propertyProjectViewMessageToOwner",
        PROPERTY_PROJECT_VIEW_TO_PROPERTY_VIEW:
            "propertyProjectViewToPropertyView",
        PROPERTY_PROJECT_VIEW_TO_PROPERTY_EDIT:
            "propertyProjectViewToPropertyEdit",
        PROPERTY_PROJECT_VIEW_TO_PERSON_VIEW: "propertyProjectViewToPersonView",
        PROPERTY_PROJECT_VIEW_TO_PERSON_EDIT: "propertyProjectViewToPersonEdit",
        PROPERTY_PROJECT_VIEW_TO_PROPERTY_PREPARE_NEW:
            "propertyProjectViewToPropertyPrepareNew",
        PROPERTY_PROJECT_VIEW_TO_PROPERTY_NEW:
            "propertyProjectViewToPropertyNew",
        PROPERTY_PROJECT_VIEW_TO_PROPERTY_EDIT_PERSON_NEW:
            "propertyProjectViewToPropertyEditPersonNew",
        PROPERTY_PROJECT_VIEW_TO_PROPERTY_EDIT_PERSON_VIEW:
            "propertyProjectViewToPropertyEditPersonView",

        PROPERTY_PROJECT_EDIT_TO_PROPERTY_VIEW:
            "propertyProjectEditToPropertyEdit",
        PROPERTY_PROJECT_PREPARE_CLONE: "propertyProjectPrepareClone",

        PROPERTY_HISTORY: "propertyHistory",
        PROPERTY_HISTORY_OPEN_PERSON: "propertyHistoryOpenPerson",
        PROPERTY_HISTORY_OPEN_PROPERTY: "propertyHistoryOpenProperty",

        PROPERTY_SOCIAL_MEDIA: "propertySocialMedia",
        PROPERTY_CONFIRMATION_MODAL: "confirmationModal",
        PROPERTY_BROCHURE: "propertyBrochure",
        PROPERTY_TRANSLATE_MODAL: "translateModal",
        PROPERTY_SMOOVED_MODAL: "SmoovedModal",
        PROPERTY_AI_DESCRIPTION_MODAL: "aiDescriptionModal",
        PROPERTY_AI_TITLE_MODAL: "aiTitleModal",
        PROPERTY_VIDEO_MANAGEMENT_WEBVIEW: "videoManagementWebview",
        PROPERTY_SEND_INVOICE: "sendInvoice"
    },
    PROJECT: {
        PROJECT_NEW: "projectNew",
        PROJECT_EDIT: "projectEdit"
    },
    CLIENT: {
        CLIENT: "client",
        CLIENT_LIST: "clientList",
        CLIENT_VIEW: "clientView",
        CLIENT_EDIT: "clientEdit",
        CLIENT_NEW: "clientNew",
        CLIENT_SEND_MESSAGE: "clientSendMessage",
        CLIENT_PRINT_TEMPLATE: "clientPrintTemplate",
        CLIENT_VIEW_PRINT_TEMPLATE: "clientViewPrintTemplate",
        CLIENT_VIEW_SEND_MESSAGE: "clientViewSendMessage",
        CLIENT_VIEW_MATCHING_SEND_MESSAGE: "clientViewMatchingSendMessage",
        CLIENT_VIEW_PROPERTY_MATCHING: "clientViewMatching",
        CLIENT_ICON: '<i class="fa fa-user-secret"></i>',
        CLIENT_HISTORY: "clientHistory",
        CLIENT_VIEW_VIEW_DEMAND: "clientViewDemand",
        CLIENT_VIEW_EDIT_DEMAND: "clientEditDemand",
        CLIENT_VIEW_VIEW_PROPERTY: "clientViewProperty",
        CLIENT_VIEW_VIEW_PROJECT: "clientViewProject",
        CLIENT_VIEW_EDIT_PROPERTY: "clientEditProperty",
        CLIENT_VIEW_NEW_DEMAND: "clientViewNewDemand",
        CLIENT_VIEW_NEW_PROPERTY: "clientViewNewProperty",
        CLIENT_VIEW_NEW_PREPARE: "clientViewNewPrepare",
        CLIENT_HISTORY_OPEN_PERSON: "clientHistoryOpenPerson",
        CLIENT_HISTORY_OPEN_PROPERTY: "clientHistoryOpenProperty"
    },
    DEMAND: {
        DEMAND: "demand",
        DEMAND_LIST: "demandList",
        DEMAND_EDIT: "demandEdit",
        DEMAND_NEW: "demandNew",
        DEMAND_SEND_MESSAGE: "demandSendMessage",
        DEMAND_PRINT_TEMPLATE: "demandPrintTemplate",
        DEMAND_DETAIL: "demandDetail",
        DEMAND_VIEW_SEND_MESSAGE: "demandViewSendMessage",
        DEMAND_VIEW_PRINT_TEMPLATE: "demandViewPrintTemplate",
        DEMAND_VIEW_MATCHING: "demandViewMatching",
        DEMAND_ICON: '<i class="fa fa-cart-plus"></i>',
        DEMAND_HISTORY: "demandHistory",
        DEMAND_DETAIL_OPEN_PERSON: "demandOpenPerson",
        DEMAND_NEW_OPEN_PERSON: "demandNewOpenPerson",
        DEMAND_EDIT_OPEN_PERSON: "demandEditOpenPerson",
        DEMAND_NEW_NEW_PERSON: "demandNewNewPerson",
        DEMAND_EDIT_NEW_PERSON: "demandEditNewPerson",
        DEMAND_HISTORY_OPEN_PERSON: "demandHistoryOpenPerson",
        DEMAND_HISTORY_OPEN_PROPERTY: "demandHistoryOpenProperty"
    },
    TASK: {
        TASK: "task",
        TASK_LIST: "taskList",
        TASK_EDIT: "taskEdit",
        TASK_NEW: "taskNew",
        TASK_VIEW: "taskView",
        TASK_VIEW_OPEN_PERSON: "taskViewOpenPerson",
        TASK_VIEW_OPEN_DEMAND: "taskViewOpenDemand",
        TASK_VIEW_OPEN_PROPERTY: "taskViewOpenProperty",
        TASK_VIEW_EDIT_PERSON: "taskViewEditPerson",
        TASK_VIEW_EDIT_DEMAND: "taskViewEditDemand",
        TASK_VIEW_EDIT_PROPERTY: "taskViewEditProperty",
        TASK_EDIT_OPEN_PERSON: "taskEditViewPerson",
        TASK_EDIT_OPEN_PROPERTY: "taskEditViewProperty",
        TASK_EDIT_OPEN_DEMAND: "taskEditViewDemand",
        TASK_EDIT_EDIT_PERSON: "taskEditEditPerson",
        TASK_EDIT_EDIT_PROPERTY: "taskEditEditProperty",
        TASK_EDIT_EDIT_DEMAND: "taskEditEditDemand",
        TASK_ICON: '<i class="fa fa-tasks"></i>',
        TAB: false,
        DIALOG: true,
        CONTAINER: true,
        CACHE: false,
        TASK_SEND_MESSAGE: "taskSendMessage"
    },
    AGENDA: {
        AGENDA: "agenda",
        AGENDA_LIST: "agendaList",
        AGENDA_EDIT: "agendaEdit",
        AGENDA_EDIT_SERIES: "agendaEditSeries",
        AGENDA_EDIT_OCCURRENCE: "agendaEditOccurrence",
        AGENDA_NEW: "agendaNew",
        AGENDA_VIEW: "agendaView",
        TASK_EDIT: "taskEdit",
        AGENDA_ICON: '<i class="fa fa-calendar"></i>',
        AGENDA_NEW_OPEN_PERSON: "agendaNewOpenPerson",
        AGENDA_EDIT_OPEN_PERSON: "agendaEditOpenPerson",
        AGENDA_NEW_OPEN_PROPERTY: "agendaNewOpenProperty",
        AGENDA_EDIT_OPEN_PROPERTY: "agendaEditOpenProperty",
        AGENDA_QUICK_PROPERTY: "agendaQuickProperty",
        AGENDA_QUICK_PERSON: "agendaQuickPerson",
        AGENDA_QUICK_DEMAND: "agendaQuickDemand",
        SEND_MESSAGE: "agendaSendMessage",
        AGENDA_CONFIRMATION: "agendaConfirmation",
        AGENDA_NEW_ADD_PERSON: "agendaNewAddPerson",
        AGENDA_EDIT_ADD_PERSON: "agendaEditAddPerson",
        AGENDA_OPEN_TASK: "agendaOpenTask",
        AGENDA_NEW_TASK: "agendaNewTask",
        AGENDA_OPEN_PERSON: "agendaOpenPerson",
        AGENDA_OPEN_PROPERTY: "agendaOpenProperty",
        AGENDA_OPEN_DEMAND: "agendaOpenDemand",
        AGENDA_SUPERAPPOINTMENT_DETAIL: "agendaSuperAppointmentDetail"
    },
    PORTAL: {
        PORTAL: "portal",
        PORTAL_UPDATE_INTERNET: "portalUpdateInternet",
        PORTAL_UPDATE_INTERNET_EDIT_DATA: "portalUpdateInternetEditData",
        PORTAL_UPDATE_INTERNET_CONFIGURATION:
            "portalUpdateInternetConfiguration",
        PORTAL_UPDATE_INTERNET_ADD_COST: "portalUpdateInternetAddCost",
        PORTAL_MEDIA_STATISTIC: "portalMediaStatistic",
        PORTAL_MEDIA_STATISTIC_ALL_PROPERTIES:
            "portalMediaStatisticAllProperties",
        PORTAL_MEDIA_STATISTIC_SELECT_A_PROPERTY:
            "portalMediaStatisticSelectAProperty"
    },
    COMPANY: {
        NEW: "companyNew",
        EDIT: "companyEdit",
        VIEW: "companyView"
    },
    DASHBOARD: "dashboard",
    MARKETING_DASHBOARD: "marketing-dashboard",
    MARKETING_DASHBOARD_WEBVIEW: "marketing-dashboard-webview",
    ADVANCE_SEARCH: "advance-search",
    MY_ACCOUNT: "my-account",
    AGENDA_CONFIGURATION: "agenda-configuration",
    CONFIGURATION: "configuration",
    VIDEO_MANAGEMENT: "video-management",
    TEMPLATE_CONFIG: "template-config",
    REPORT: {
        LARGE_MAILING: "largeMailing",
        SMS_MESSAGE: "smsMessage"
    },
    MANAGEMENT: "management",
    ABOUT: "about",
    WEB_PAGE: {
        REQUEST_OF_PROPERTY_DOCUMENTS: "request-of-property-documents"
    }
};

export const EVENT_BUS = {
    PROPERTY: {
        REFRESH_GRID: "PROPERTY_REFRESH_GRID",
        BROADCAST_CURRENT_PROPERTY: "BROADCAST_CURRENT_PROPERTY",
        BROADCAST_PROPERTY_FILE_UPLOADING: "BROADCAST_PROPERTY_FILE_UPLOADING",
        BROADCAST_PROPERTY_FILE_COMPLETE: "BROADCAST_PROPERTY_FILE_COMPLETE",
        LIST_OF_PROPERTY: "list-of-properties",
        AGENDA_MODAL: "PROPERTY_AGENDA_MODAL",
        CLIENT_VIEW: "PROPERTY_CLIENT_VIEW",
        PROJECT_VIEW: "PROPERTY_PROJECT_VIEW",
        CLIENT_PROPOSAL_VIEW: "PROPERTY_CLIENT_PROPOSAL_VIEW",
        ADD_RELATION: "ADD_RELATION",
        CLEAR_MEMORY: "PROPERTY_CLEAR_MEMORY",
        SIGN_DOCUMENT: "SIGN_DOCUMENT",
        REFRESH_DOCUMENT: "REFRESH_DOCUMENT",
        CREATE_PROPERTY_SUCCESS: "PROPERTY_CREATE_PROPERTY_SUCCESS",
        RELATION: {
            CREATE_TASK: "PROPERTY_RELATION_CREATE_TASK"
        },
        SMOOVED_DRAWER_CLOSE: "SMOOVED_DRAWER_CLOSE",
        FORCE_SAVE: "force-save",
        CAN_FORCE_SAVE: "CAN_FORCE_SAVE",
        VIDEO_MANAGEMENT_SELECTED: "VIDEO_MANAGEMENT_SELECTED",
        VIDEO_UPLOAD_SUCCESS: "VIDEO_UPLOAD_SUCCESS"
    },
    PERSON: {
        BROADCAST_PERSON_FILE_UPLOADING: "BROADCAST_PERSON_FILE_UPLOADING",
        BROADCAST_PERSON_FILE_COMPLETE: "BROADCAST_PERSON_FILE_COMPLETE",
        CLEAR_MEMORY: "PERSON_CLEAR_MEMORY",
        CREATE_PERSON_SUCCESS: "PERSON_CREATE_PERSON_SUCCESS",
        EDIT_PERSON_SUCCESS: "PERSON_EDIT_PERSON_SUCCESS",
        NOTIFY_REFRESH_PERSON: "PERSON_NOTIFY_REFRESH_PERSON",
        CONFLICT_ACTION: "PERSON_CONFLICT_ACTION",
        CREATE_COMPANY_SUCCESS: "PERSON_CREATE_COMPANY_SUCCESS"
    },
    COMPANY: {
        NOTIFY_REFRESH_COMPANY: "COMPANY_NOTIFY_REFRESH_COMPANY"
    },
    TASK: {
        REFRESH_GRID: "TASK_REFRESH_GRID",
        CREATE_TASK_SUCCESS: "CREATE_TASK_SUCCESS",
        CLEAR_MEMORY: "TASK_CLEAR_MEMORY",
        TASK_CONVERT_TO_AGENDA_SUCCESS: "TASK_CONVERT_TO_AGENDA_SUCCESS",
        NOTIFY_REFRESH_TASK: "TASK_NOTIFY_REFRESH_TASK"
    },
    CLIENT: {
        REFRESH_GRID: "CLIENT_REFRESH_GRID",
        LIST_OF_PERSON: "LIST_OF_PERSON",
        AGENDA_MODAL: "CLIENT_AGENDA_MODAL",
        DEMAND_MODAL: "CLIENT_DEMAND_MODAL",
        DEMAND_MODAL_GENERAL: "CLIENT_DEMAND_MODAL_GENERAL",
        PROJECT_VIEW: "CLIENT_PROJECT_VIEW",
        PROPERTY_VIEW: "CLIENT_PROPERTY_VIEW",
        PROPERTY_MODAL_RELATION_INSTALLMENT:
            "CLIENT_PROPERTY_MODAL_RELATION_INSTALLMENT",
        PROPERTY_MODAL_RELATION_ADD: "CLIENT_PROPERTY_MODAL_RELATION_ADD",
        PROPERTY_VIEW_FORM_ADD_RELATION: "PROPERTY_VIEW_FORM_ADD_RELATION"
    },
    DEMAND: {
        CLIENT_VIEW: "DEMAND_CLIENT_VIEW",
        REFRESH_GRID: "DEMAND_REFRESH_GRID",
        CLEAR_MEMORY: "DEMAND_CLEAR_MEMORY",
        LIST_OF_DEMAND: "LIST_OF_DEMAND",
        CLOSE_MATCHING_MODAL: "DEMAND_CLOSE_MATCHING_MODAL",
        NOTIFY_REFRESH_DEMAND: "DEMAND_NOTIFY_REFRESH_DEMAND"
    },
    FAVORITE_FILTER: {
        CHANGE: "FAVORITE_FILTER_CHANGE",
        IS_WIN_APP: "WIN_APP_FAVORITE_FILTER",
        ADD: "FAVORITE_FILTER_ADD",
        CANCEL: "FAVORITE_FILTER_CANCEL"
    },
    FILTER: {
        CHANGE: "FILTER_CHANGE"
    },
    UPLOAD_CONTROL: {
        CANCEL_SINGLE_FILE: "UPLOAD_CONTROL_CANCEL_SINGLE_FILE",
        CANCEL_ALL: "UPLOAD_CONTROL_CANCEL_ALL",
        UPDATE_COMMON_UPLOAD_ID: "COMMON_UPDATE_COMMON_UPLOAD_ID",
        UPDATE_COMMON_UPLOAD_ID_AI_IMAGE: "UPDATE_COMMON_UPLOAD_ID_AI_IMAGE",
        UPLOAD_SUCCESS: "COMMON_UPLOAD_SUCCESS",
        LOAD_UPLOADED_DOCUMENT: "COMMON_LOAD_UPLOADED_DOCUMENT",
        LOAD_UPLOADED_PICTURE: "COMMON_LOAD_UPLOADED_PICTURE",
        LOAD_UPLOADED_VIDEO: "COMMON_LOAD_UPLOADED_VIDEO",
        REPLACE_PROPERTY_PICTURE: "COMMON_REPLACE_PICTURE",
        DRAG_DROP_FILES: "COMMON_DRAG_DROP_FILES",
        RETRY_UPLOAD_SINGLE_FILE: "COMMON_RETRY_UPLOAD_SINGLE_FILE"
    },
    COMMON: {
        LOADED_TRANSALTED: "LOADED_TRANSALTED",
        WARNING_CLOSE_MODAL: "COMMON_WARNING_CLOSE_MODAL",
        DRAWER_CLOSE: "COMMON_DRAWER_CLOSE",
        SET_LOADING_OFF: "COMMON_SET_LOADING_OFF",
        SKIP_NAVIGATION: "COMMON_SKIP_NAVIGATION",
        AI_SHOW_GENERATE: "AI_SHOW_GENERATE"
    },
    HISTORY: {
        UPDATE_HISTORY_LIST: "UPDATE_HISTORY_LIST",
        NEW_CLIENT: "HISTORY_NEW_CLIENT",
        REFRESH_HISTORY_UPDATE_DOCUMENT: "REFRESH_HISTORY_UPDATE_DOCUMENT"
    },
    NOTIFICATION: {
        NOTIFICATION_HUB_FETCH_DATA: "NOTIFICATION_HUB_FETCH_DATA",
        NOTIFICATION_PUSH_ITEM: "NOTIFICATION_PUSH_ITEM",
        NOTIFICATION_MAILING_HTML: "NOTIFICATION_MAILING_HTML",
        NOTIFICATION_LOG_INCOMING_CALL: "NOTIFICATION_LOG_INCOMING_CALL"
    },
    RELATION: {
        UPDATE_RELATION: "RELATION_UPDATE_RELATION",
        UPDATE_RELATION_TO_PARENT: "RELATION_UPDATE_RELATION_TO_PARENT",
        ACA_ORDER_PUBLISHED: "RELATION_ACA_ORDER_PUBLISHED",
        IMMOWINKEL_ORDER_PUBLISHED: "RELATION_IMMOWINKEL_ORDER_PUBLISHED",
        KORFINE_ORDER_PUBLISHED: "RELATION_KORFINE_ORDER_PUBLISHED"
    },
    RUNNING_TASK: {
        PUBLISH_FILE_START: "RUNNING_TASK_PUBLISH_FILE_START",
        SEND_LARGE_MAILING_START: "RUNNING_TASK_SEND_LARGE_MAILING_START",
        SEND_MAIL_START: "RUNNING_TASK_SEND_MAIL_START",
        COMPLETE: "RUNNING_TASK_COMPLETE",
        FAIL: "RUNNING_TASK_FAIL",
        OPEN: "RUNNING_TASK_OPEN",
        SCHEDULED: "RUNNING_TASK_SCHEDULED"
    },
    AGENDA: {
        NOTIFY_APPOINTMENT_WAS_DELTED: "NOTIFY_APPOINTMENT_WAS_DELTED",
        NOTIFY_REFRESH_APPOINTMENT: "NOTIFY_REFRESH_APPOINTMENT",
        CREATE_NEW_TASK: "AGENDA_CREATE_NEW_TASK",
        CREATE_NEW_APPOINTMENT: "AGENDA_CREATE_NEW_APPOINTMENT"
    },
    SOCIAL: {
        RELOAD_AUDIO: "SOCIAL_RELOAD_AUDIO",
        SELECTED_PICTURES_OVER: "SELECTED_PICTURES_OVER"
    },
    DIALOG: {
        ADD: "ADD_DIALOG"
    },
    AI_IMAGE: {
        OPEN_BULK: 'AI_IMAGE_OPEN_BULK',
        CLOSE: 'AI_IMAGE_CLOSE',
        REPLACE_COMPLETE: 'AI_IMAGE_REPLACE_COMPLETE',
        CHECK_RESTORE: 'AI_IMAGE_CHECK_RESTORE',
        EXPAND_SESSION: 'AI_IMAGE_EXPAND_SESSION',
    },
    DOCUMENT_AI: {
        OPEN: 'DOCUMENT_AI_OPEN',
        EXPAND_JOB: 'DOCUMENT_AI_EXPAND_JOB',
    },
    AUTH: {
        // Emitted after every token refresh (axios-helper and plugin/signalr); the
        // embedded-app broker pushes ACCESS_TOKEN to active iframes.
        STATE_CHANGED: 'AUTH_STATE_CHANGED',
        // Emitted with 'logout' | 'session-expired' right before the WebApp drops its
        // session; the broker broadcasts AUTH_LOGOUT.
        SIGNED_OUT: 'AUTH_SIGNED_OUT'
    }
};

export const COLOR_NUMBER = {
    CLEAR: 0,
    TRANSPARENT: 16777215,
    WHITE: -1
};

export const VIEW_MODES = [
    { id: "Grid", name: "CARD_VIEW", icon: "ico_list" },
    { id: "Card", name: "GRID_VIEW", icon: "ico_grid" }
];

export const DEFAULT_GRID_VIEW_MODES = [
    { id: "Grid", name: "CARD_VIEW", icon: "ico_list" }
];

export const DEFAULT_CARD_VIEW_MODES = [
    { id: "Card", name: "GRID_VIEW", icon: "ico_grid" }
];

export const DEFAULT_NUMBER_DECIMAL = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
};

export const SORT_OPTIONS = [
    "HIGHEST_PRICE",
    "LOWEST_PRICE",
    "NEWEST_LISTED",
    "OLDEST_LISTED"
];

export const MEDIA_ID = {
    IMMOWEB: 2
};

export const MEDIA_PUB_PLAN_ACTION = {
    SELECT_PLAN: "SelectPlan",
    IMMOWEB_OPTION: "ImmoWebOption",
    IMMOWEB_START_DATE: "ImmoWebStartDate",
    IMMOWEB_DETAILED_PAGE: "ImmoWebDetailedPage",
    TYPE_OF_PROP: "TypeOfProp"
};

export const MEDIA_PUB_PLAN_RESPONSE = {
    UPDATE_PLAN: "UpdatePlan",
    CONFIRT_TO_UPDATE_REVERT: "ConfirmToUpdateOrRevert",
    CONFIRM_TO_UPDATE: "ConfirmToUpdate",
    NONE: "None"
};

export const LOADING_IMAGE =
    "data:image/svg+xml;base64,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";

export const NO_IMAGE = getBaseIconResourceUrl() + "/small/no_pic.gif";
export const NO_PHOTO = getBaseIconResourceUrl() + "/small/no_photo.svg";

export const PICTURE_TYPES = {
    PROJECT_PICTURE: "ProjectPicture",
    PROJECT_EVOLUTION: "ProjectEvolution",
    OBJECT_PICTURE: "ObjectPicture",
    INVENTORY_PICTURE: "InventoryPicture",
    PROJECT_ENVIRONMENT: "ProjectEnvironment",
    PROJECT_SITUATION: "ProjectSituation",
    PROJECT_FEATURE: "ProjectFeature",
    NEIGHBOURHOODS: "Neighbourhoods"
};

export const EPC_BRUSSELS = {
    1001: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1001.png",
    1002: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1002.png",
    1003: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1003.png",
    1004: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1004.png",
    1005: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1005.png",
    1006: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1006.png",
    1007: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1007.png",
    1008: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1008.png",
    1009: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1009.png",
    1010: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1010.png",
    1011: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1011.png",
    1012: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1012.png",
    1013: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1013.png",
    1014: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1014.png",
    1015: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1015.png",
    1016: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1016.png",
    1017: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1017.png",
    1018: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1018.png",
    1019: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1019.png"
};

export const EPC_WALLONIA = {
    1: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_1.png",
    2: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_2.png",
    3: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_3.png",
    4: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_4.png",
    5: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_5.png",
    6: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_6.png",
    7: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_7.png",
    8: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_8.png",
    9: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_9.png",

    10: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_10.png",
    11: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_11.png",
    12: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_12.png",
    13: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_13.png",
    14: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_14.png",
    15: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_15.png",
    16: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_16.png",
    17: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_17.png",
    18: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_18.png",
    19: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_19.png",
    20: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_20.png",
    21: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_21.png",
    22: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_22.png",
    23: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_23.png",
    24: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_24.png",
    25: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_25.png",
    26: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_26.png",
    27: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_27.png",
    28: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_28.png",
    29: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_29.png",
    30: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_30.png",
    31: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_31.png",
    32: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_32.png",
    33: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_33.png",
    34: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_34.png",
    35: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_35.png",
    36: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_36.png",
    37: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_37.png",
    38: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_38.png",
    39: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_39.png",
    40: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_40.png",
    41: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_41.png",
    42: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_42.png",
    43: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_43.png",
    44: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_44.png",
    45: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_45.png"
};

export const EPC_FLANDERS = {
    10001: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_10001.png",
    10002: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_10002.png",
    10003: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_10003.png",
    10004: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_10004.png",
    10005: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_10005.png",
    10006: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_10006.png",
    10007: SERVICE_LINKS.EPC_LABEL_URL + "/images/EPClabel/peb_10007.png"
};

export const PROSPECTIVE = 0;

export const CALCULATOR = {
    HEIGHT: "changeHeight"
};

export const CONSTRUCTION_TYPE = {
    Property: 0,
    Project: 1,
    Unit: 2,
    Annex: 3
};

export const PUBLISH_MEDIA_TYPE = {
    PICTURE: 0,
    VIDEO: 1,
    CAROUSEL: 2
};

export const PUBLISH_INFO_OPTIONS = {
    HasAlbums: "HasAlbums",
    HasPicture: "HasPicture",
    HasVideoAudio: "HasVideoAudio",
    HasVideoGallery: "HasVideoGallery",
    HasPubText: "HasPubText",
    HasBoard: "HasBoard",
    HasMessage: "HasMessage"
};

export const SOCIAL_PLATFORM_TYPE = {
    FACEBOOK: 0,
    TWITTER: 1,
    LINKED_IN: 2,
    PINTEREST: 3,
    INSTAGRAM: 4,
    N_INSTAGRAM: 5
};

export const IMAGE_LAZY_LOAD_STATUS = {
    UNLOADED: 0,
    LOADED: 2
};

export const SOCIAL_CHECK_STATUS_CODE = {
    SESSION_NOT_FOUND: -1,
    PROCESSING: 0,
    SUCCESS: 2,
    FAILED: 3,
    SCHEDULED: 4
};

export const OMNICASA_MAP_BASE_URL =
    "https://geomap." + DEFAULT_DOMAIN + "/Page/OmnicasaMap.aspx";

export const HERITAGE_VERIFY_FIELDS = [
    "address",
    "cityName",
    "houseNumber",
    "cityPostCode"
];

export const MODULE_NAME = {
    PROEJECT: "projects",
    PROPERTY: "properties",
    DEMAND: "demands",
    PERSON: "person",
    TASK: "tasks"
};

export const LEAVE_PAGE_CONFIRM_ACTIONS = {
    SAVE: "save",
    CONTINUE: "continue",
    DISCARD: "discard"
};

export const PAGE_VIEW_TYPES = {
    DETAIL: "detail",
    EDIT: "edit",
    NEW: "new",
    SEARCH: "search"
};

export const HISTORY_MODES = {
    HISTORY: 1,
    TASK: 2,
    AGENDA: 0
};

export const QUICK_VIEW_TYPES = {
    property: "property",
    project: "project",
    client: "client",
    demand: "demand",
    task: "task"
};

export const PERSON_FORM_MAIN_TABS = {
    GENERAL: "general",
    DETAIL: "detail",
    DOCUMENT: "document",
    RELATION: "relation"
};

export const COMPANY_FORM_MAIN_TABS = {
    GENERAL: "general",
    DOCUMENT: "document"
};

export const DEMAND_FORM_MAIN_TABS = {
    GENERAL: "general"
};

export const TASK_FORM_MAIN_TABS = {
    GENERAL: "general"
};

export const CONFIG_FORM_DATA_TYPES = {
    PROPERTY: "properties",
    DEMAND: "demands",
    PERSON: "persons",
    AGRNDA: "appointments"
};

export const GRID_LIST_RERENDER_LIMIT = 10;
export const CANCEL_REQUEST_BY_USER_MESSAGE = "CANCEL_REQUEST_BY_USER";

export const PERSON_TYPES = {
    PERSON: 0,
    COMPANY: 1
};

export const PROPERTY_PURPOSES = {
    FOR_SALE: 0,
    FOR_RENT: 1
};

export const LIST_SORT_CRITERIA = {
    ASC: 1,
    DES: -1,
    NONE: 0
};

export const ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG = {
    DO_NOT_ADD: 0,
    AUTO_ADD_TO_RESOURCE: 1,
    SET_MANAGER_BE_RESOURCE: 2
};

export const WEBVIEW_TOKEN_QUERY = "webview-token";
export const WEBVIEW_REFRESH_TOKEN_QUERY = "webview-refresh-token";
export const WEBAPP_LAYOUT = {
    DEFAULT: "Default",
    WEBVIEW: "Webview"
};

export const PROPERTY_INVOICE_PERMISSION = {
    NO_ACCESS: 0,
    READ_ONLY: 1,
    READ_WRITE: 2
};

export const EXCHANGE_SERVER = {
    OFFICE_365: 0,
    GOOGLE: 1,
    EXCHANGE: 2
};
export const NOTIFICATION_CENTER_TYPES = {
    PHONE_CALL: "PhoneCall",
    NOTIFICATION_POPUP: "NotificationPopup"
};

export const PASSWORD_TYPES = {
    NORMAL: "normal"
};

export const LANG_NUMBER = {
    EN: 3,
    NL: 1,
    FR: 2,
    DE: 4
};

export const AI_CONSTANTS: { LANGUAGES: Array<{ langName: string, langId: number }> } = {
    LANGUAGES: [{ langName: 'ENGLISH', langId: LANG_NUMBER.EN }, { langName: 'FRANCE', langId: LANG_NUMBER.FR }, { langName: 'DUTCH', langId: LANG_NUMBER.NL }, { langName: 'GERMAN', langId: LANG_NUMBER.DE }]
}

export const getUserRightConfirmMessage = (userName, lang) => {
    switch (lang) {
        case LANG_NUMBER.NL:
            return {
                title:
                    "You loged in with super password. Do you want to continue with rights:",
                op1: `of the user ${userName}`,
                op2: "all right"
            };
        case LANG_NUMBER.FR:
            return {
                title:
                    "You loged in with super password. Do you want to continue with rights:",
                op1: `of the user ${userName}`,
                op2: "all right"
            };
        default:
            return {
                title:
                    "You loged in with super password. Do you want to continue with rights:",
                op1: `of the user ${userName}`,
                op2: "all right"
            };
    }
};
export const NOT_FOUND = "Not Found";
export const SOCIAL_LIMIT_PICTURE = 15;
export const SOCIAL_LIMIT_PICTURE_CAROUSEL = 10;
export const SOCIAL_LIMIT_PICTURE_LINKEDIN = 20;
export const VIEW_MODES_MAP = {
    0: "Grid",
    1: "Card"
};
export const PROPERTY_CONFIG_KEYS = [
    "AutoTranslateLanguage",
    "AutoTranslatePropertyDescriptionA",
    "AutoTranslatePropertyDescriptionB",
    "AutoTranslatePropertyPubTextA",
    "AutoTranslatePropertyPubTextB",
    "AutoTranslatePropertyPubTextC",
    "AutoTranslatePropertyPubTextD"
];
export const PROJECT_CONFIG_KEYS = [
    "AutoTranslateLanguage",
    "AutoTranslateProjectDescriptionInfo",
    "AutoTranslateProjectDescriptionA",
    "AutoTranslateProjectDescriptionB"
];

export const AIConfigs = ["UseGenerateAI"];

export const DATA_TYPES = [
    {
        key: "TYPE_OF_CONTRACT",
        name: "Type of contract",
        value: 18
    },
    {
        key: "RENTAL_REGIME",
        name: "Rental regime",
        value: 19
    },
    {
        key: "SORT",
        name: "Sort",
        value: 22
    },
    {
        key: "SORT2",
        name: "Sort2",
        value: 23
    },
    {
        key: "ESTATE_CATEGORY",
        name: "EstateCategory",
        value: 21
    },
    {
        key: "OWNER_CATEGORY",
        name: "OwnerCategory",
        value: 20
    },
    {
        key: "TENANT_CATEGORY",
        name: "TenantCategory",
        value: 20
    },
    {
        key: "DOCUMENT_TYPE",
        name: "Document Type",
        value: 25
    },
    {
        key: "SUBTYPE",
        name: "Subtype",
        value: 26
    }
];

export const USERCONFIGKEYS = {
    selectUserCanSeeMyAgenda: "SELECTUSERCANSEEMYAGENDA",
    listUserIdCanSeeMyAgenda: "LISTUSERIDCANSEEMYAGENDA"
};

export enum CONFIG_SEE_AGENDA {
    ALL = 'ALL',
    NONE = 'NONE',
    SELECT = 'SELECT'
};

export enum PROVIDER_AUTO_TRANSLATION {
    NONE = 0,
    GOOGLE = 1,
    DEEPL = 2,
    OPEN_AI = 3
}

export const TIME_TO_RELOAD_CHANGE_LOCALE = 2000;

export const CACHE_COMPONENT_NAME = [
    ROUTER.PROPERTY.PROPERTY, ROUTER.CLIENT.CLIENT, ROUTER.DEMAND.DEMAND, ROUTER.TASK.TASK, ROUTER.AGENDA.AGENDA,
    'property-detail-view', 'PersonDetailModal', 'DemandDetailComponent', 'TaskDetailViewComponent', 'projectView', 'CompanyDetail', ROUTER.EMAIL_WEBSITE
]
